/* eslint-disable jsx-a11y/no-autofocus */
import React, { useRef, useState } from "react"
import { PropTypes } from "prop-types"
import { connect } from "react-redux"
import withImmutablePropsToJS from "with-immutable-props-to-js"

import { useOnClickOutside } from "app/static/frontend/imports/hooks"

// components
import { DropdownSelect } from "quorumdesign"
import { IssueManagementSelect } from "app/static/frontend/selects/containers/PieSelect"

// action creators
import { getIssues, addToIssue, removeFromIssue } from "shared/profiles/issueAdder/action-creators"
import { segueToProfileWithId } from "app/static/frontend/global-action-creators"
import { updateCellExtraAndPatchValue } from "app/static/frontend/search-new/containers/TableView/action-creators"

// selectors
import resourceTableIssueAdderConnection from "app/static/frontend/components/ResourceTableIssueAdder/selectors"

// action types
import { removeFromIssuesResourceTable } from "shared/profiles/issueAdder/action-types"

// constants
import { columnWidthConstants } from "app/static/frontend/search-new/containers/TableView/constants"

export const ResourceTableIssueAdder = (props) => {
    const [isPopUpOpen, setIsPopUpOpen] = useState(false)
    const resourceTableIssueAdderRef = useRef()
    useOnClickOutside(resourceTableIssueAdderRef, () => setIsPopUpOpen(false))

    const togglePopupIsOpen = () => {
        setIsPopUpOpen(!isPopUpOpen)
    }

    const assignIssue = (issue) =>
        updateCellExtraAndPatchValue({
            updateResourceTableRow: props.updateResourceTableRow,
            tableId: props.tableId,
            rowId: props.rowId,
            patchValueFunction: props.addToIssue,
            patchValueArgs: {
                qdt: props.quorumDataTypeEnum,
                id: props.rowId,
                issue,
            },
            updateExtraObj: { issues: [...props.formattedIssues, issue] },
            updateExtraRollbackObj: { issues: props.formattedIssues },
        })

    const unassignIssue = (issue) =>
        updateCellExtraAndPatchValue({
            updateResourceTableRow: props.updateResourceTableRow,
            tableId: props.tableId,
            rowId: props.rowId,
            patchValueFunction: props.removeFromIssue,
            patchValueArgs: {
                qdt: props.quorumDataTypeEnum,
                id: props.rowId,
                issue,
                // want to override action types because we are already updating issues in sheet store
                overwriteActionTypes: removeFromIssuesResourceTable,
            },
            updateExtraObj: {
                issues: props.formattedIssues.filter((currentIssue) => currentIssue.id !== issue.id),
            },
            updateExtraRollbackObj: { issues: props.formattedIssues },
        })

    return (
        <DropdownSelect
            dataCy="issues-search-table-column"
            buttonIcon="thumbtack"
            buttonIconFamily="far"
            buttonOnClickCallback={() =>
                props.getIssues({
                    qdt: props.quorumDataTypeEnum,
                    id: props.rowId,
                })
            }
            buttonType="resource-table-dropdown"
            buttonText={props.buttonText}
            buttonMaxTextWidth={props.buttonTextWidth}
            isPopUpOpen={isPopUpOpen}
            maxWidth={`${columnWidthConstants.ISSUES_COLUMN_WIDTH}px`}
            clickOutsideRef={resourceTableIssueAdderRef}
            SelectComponent={
                <IssueManagementSelect
                    isDesignSystem
                    onChange={assignIssue}
                    value={0}
                    defaultMenuIsOpen
                    autoFocus
                    isFocused
                    requiresBaseComponent
                    permanentFilter={{ dehydrate_extra: ["parent_name", "ancestors"] }}
                />
            }
            togglePopupIsOpen={togglePopupIsOpen}
            values={props.formattedIssues}
            valueStripOnClick={(issue) =>
                props.segueToProfileWithId(issue.id, DjangIO.app.models.QuorumDataType.issue_management.value)
            }
            valueStripRemove={(issue) => unassignIssue(issue)}
        />
    )
}

ResourceTableIssueAdder.propTypes = {
    // from mapDispatchToProps
    addToIssue: PropTypes.func.isRequired,
    getIssues: PropTypes.func.isRequired,
    removeFromIssue: PropTypes.func.isRequired,
    segueToProfileWithId: PropTypes.func.isRequired,

    // from resourceTableIssueAdderConnection
    buttonText: PropTypes.string.isRequired,
    formattedIssues: PropTypes.array.isRequired,
    quorumDataTypeEnum: PropTypes.object.isRequired,

    // passed to component
    buttonTextWidth: PropTypes.string,
    rowId: PropTypes.number.isRequired,
    tableId: PropTypes.string.isRequired,
    updateResourceTableRow: PropTypes.func.isRequired,
}

export default connect(resourceTableIssueAdderConnection, {
    addToIssue,
    getIssues,
    removeFromIssue,
    segueToProfileWithId,
})(withImmutablePropsToJS(ResourceTableIssueAdder))
